export default "__VITE_ASSET__7708df49__"